import React from 'react'
import infoIcon from 'app/livbrite/resources/images/information.png'
import { LoginForm } from 'app/livbrite/components/LoginForm'
import { PublicLayout } from 'app/livbrite/components/PublicLayout'

export const Login = () => {
  return (
    <PublicLayout>
      <div>
        <h2>
          Welcome
        </h2>
        <LoginForm shouldRedirectToAccount />
        <span
          className='help contact-trigger'
        >
          Need Help?
          <img src={infoIcon} alt='Information' />
        </span>
      </div>
    </PublicLayout>
  )
}
